<template>
    <div class="card">
        <div class="card-header">Výpisy</div>
        <div class="card-body pt-3 pl-3 pr-3">
            <Loading class="mt-2 mb-2" v-if="loading"/>
            <div class="text-center" v-if="!loading && !items.length">
                <small>V schránke sa nenachádzajú žiadne výpisy.</small>
            </div>
            <table class="table table-standard table-sm" v-if="!loading  && items.length">
                <thead>
                <tr>
                    <th>Dátum prijatia</th>
                    <th>Predmet</th>
                    <th>Typ</th>
                    <th>Súbor</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in items" :class="{'grey-row': item.read}">
                    <td>{{item.date|date}}</td>
                    <td>{{item.subject}}</td>
                    <td>{{item.type}}</td>
                    <td>
                        <a @click="downloadAttachment(item.idExport, index)" class="text-primary c-pointer">
                            <font-awesome-icon :icon="['far', 'file-alt']"/>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import Loading from "../../../components/Loading";
    export default {
        name: "Exports",
        components: {
            Loading
        },
        computed: {
            loading() {
                return this.$store.state.exports.loading;
            },
            items() {
                return this.$store.state.exports.items;
            }
        },
        methods: {
            downloadAttachment(exportId, index) {
                if (!this.items[index].read) {
                    this.items[index].read = true;
                    this.$store.dispatch('exports/markRead', {
                        id: exportId,
                        index: index
                    }).then(() => {
                        this.$store.dispatch('message/status');
                    });
                }

                this.$store.dispatch('exports/exportAttachment', {
                    exportId: exportId
                });
            },
        }
    }
</script>

<style scoped>

</style>